module.exports = __webpack_public_path__ + "static/media/superai_text_md.57ded915.png";